import { ButtonList } from '@/lib/base/button-list';
import { Toggle } from '@/lib/base/forms/toggle';

interface EmailComposeToggleRowsProps {
  signatureEnabled: boolean;
  footerEnabled: boolean;
  footerLocked: boolean;
  onSignatureChange: (enabled: boolean) => void;
  onFooterChange: (enabled: boolean) => void;
  signatureSaving?: boolean;
  footerSaving?: boolean;
}

/**
 * Presentational Email Signature + Ahoy Footer toggle rows shared by the
 * settings page and the email-preview modal. Owns no state and makes no
 * network calls — the consumer supplies data and callbacks and wraps these
 * rows in its own `ButtonList`.
 */
export function EmailComposeToggleRows({
  signatureEnabled,
  footerEnabled,
  footerLocked,
  onSignatureChange,
  onFooterChange,
  signatureSaving = false,
  footerSaving = false,
}: EmailComposeToggleRowsProps) {
  return (
    <>
      <ButtonList.Item
        trailing={
          <Toggle
            isSelected={signatureEnabled}
            onChange={onSignatureChange}
            isDisabled={signatureSaving}
            aria-label='Email signature'
          />
        }
      >
        <p className='text-sm font-medium text-fg-primary mb-0.5'>
          Email signature
        </p>
        <p className='text-sm text-fg-tertiary'>
          Automatically adds your email signature when sending, if you have one
          set.
        </p>
      </ButtonList.Item>
      <ButtonList.Item
        trailing={
          <Toggle
            isSelected={footerLocked ? true : footerEnabled}
            onChange={onFooterChange}
            isDisabled={footerLocked || footerSaving}
            aria-label='Ahoy footer'
          />
        }
      >
        <p className='text-sm font-medium text-fg-primary mb-0.5'>
          Ahoy footer
        </p>
        <p className='text-sm text-fg-tertiary'>
          Add &ldquo;Shipped via Ahoy&rdquo; link to outgoing emails
        </p>
        {footerLocked && (
          <p className='text-xs text-fg-quaternary mt-1'>
            Included on free plans. Upgrade to turn it off.
          </p>
        )}
      </ButtonList.Item>
    </>
  );
}
